import { List } from "models/list";
import { ListUser } from "models/list-user";
import { doGet } from "services/request";

export const sharedDoGetListUsers = async (list: List) => {
  const users = await doGet<ListUser[]>(`/shared/list/${list.uuid}/users`);
  return users;
};

export const sharedDoGetListUser = async (list: List, userUuid: string) => {
  const user = await doGet<ListUser>(
    `/shared/list/${list.uuid}/user/${userUuid}`,
  );
  return user;
};
